module.exports = __webpack_public_path__ + "static/media/IMG_2421.bff70c2b.JPG";